import { render, staticRenderFns } from "./PlanDetailsPage.vue?vue&type=template&id=4dc8b094&scoped=true"
import script from "./PlanDetailsPage.vue?vue&type=script&lang=js"
export * from "./PlanDetailsPage.vue?vue&type=script&lang=js"
import style0 from "./PlanDetailsPage.vue?vue&type=style&index=0&id=4dc8b094&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4dc8b094",
  null
  
)

export default component.exports